"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fp = _interopRequireDefault(require("lodash/fp"));

var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));

var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _icons = require("@material-ui/icons");

var _DrawerEntry = _interopRequireDefault(require("@fe/ui/Drawer/DrawerEntry"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DrawerMenuItem = /*#__PURE__*/function (_React$Component) {
  _inherits(DrawerMenuItem, _React$Component);

  var _super = _createSuper(DrawerMenuItem);

  function DrawerMenuItem() {
    var _this;

    _classCallCheck(this, DrawerMenuItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      open: false
    });

    _defineProperty(_assertThisInitialized(_this), "toggleOpen", function (e) {
      _this.setState(_fp.default.update('open', function (open) {
        return !open;
      }));
    });

    return _this;
  }

  _createClass(DrawerMenuItem, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var accessibleRoutes = _fp.default.filter(function (r) {
        return !_fp.default.get("".concat(r, ".role"), _this2.props.routeList) || _fp.default.includes(_fp.default.get("".concat(r, ".role"), _this2.props.routeList), _this2.props.roles) || _this2.props.isAdmin;
      }, this.props.routes);

      if ((_fp.default.isEmpty(accessibleRoutes) || this.props.requiresAdmin && !this.props.isAdmin) && _fp.default.isEmpty(this.props.children)) {
        return false;
      }

      if (_fp.default.size(accessibleRoutes) === 1 && !this.props.children) {
        return /*#__PURE__*/_react.default.createElement(_DrawerEntry.default, {
          currentItemId: this.props.currentItemId,
          currentPath: this.props.currentPath,
          route: _fp.default.first(accessibleRoutes),
          icon: this.props.icon,
          routes: this.props.routeList,
          onClick: this.props.onClick
        });
      }

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ListItem.default, {
        button: true,
        onClick: this.toggleOpen
      }, /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, null, this.props.icon), /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
        inset: !this.props.icon,
        primary: this.props.name || '',
        primaryTypographyProps: {
          variant: 'subtitle1'
        }
      }), this.state.open ? /*#__PURE__*/_react.default.createElement(_icons.ExpandLess, null) : /*#__PURE__*/_react.default.createElement(_icons.ExpandMore, null)), /*#__PURE__*/_react.default.createElement(_Collapse.default, {
        component: 'li',
        in: this.state.open,
        timeout: "auto",
        unmountOnExit: true
      }, /*#__PURE__*/_react.default.createElement(_List.default, {
        disablePadding: true
      }, this.props.children, _fp.default.map.convert({
        cap: false
      })(function (a, idx) {
        return a === '-' ? /*#__PURE__*/_react.default.createElement(_Divider.default, {
          key: "".concat(idx).concat(a)
        }) : /*#__PURE__*/_react.default.createElement(_DrawerEntry.default, {
          key: "".concat(idx).concat(a),
          currentItemId: _this2.props.currentItemId,
          currentPath: _this2.props.currentPath,
          route: a,
          routes: _this2.props.routeList,
          onClick: _this2.props.onClick
        });
      }, accessibleRoutes))));
    }
  }]);

  return DrawerMenuItem;
}(_react.default.Component);

_defineProperty(DrawerMenuItem, "propTypes", {
  name: _propTypes.default.string,
  icon: _propTypes.default.node,
  routes: _propTypes.default.array,
  roles: _propTypes.default.array.isRequired,
  currentItemId: _propTypes.default.any,
  currentPath: _propTypes.default.any,
  isAdmin: _propTypes.default.bool,
  requiresAdmin: _propTypes.default.bool,
  routeList: _propTypes.default.object.isRequired
});

_defineProperty(DrawerMenuItem, "defaultProps", {
  requiresAdmin: false
});

var _default = DrawerMenuItem;
exports.default = _default;